module.exports = __webpack_public_path__ + "img/signature-lock.bdb4ee7.svg";